import enVuetify from 'vuetify/src/locale/en';
import enLocal from '../assets/translations/en.json';

export const en = {
  $vuetify: {
    ...enVuetify,
  },
  ...enLocal,
};
